/* eslint-disable */
import { Check } from 'lucide-react';
import React from 'react';

function Stepper(props) {
    const { steps = [], currentStep = 1 } = props;

    return (
        <div className='relative flex items-center justify-between w-full max-w-2xl mx-auto'>
            {/* Continuous background line behind all circles */}
            <div
                className='absolute h-[3px] bg-gray-300'
                style={{
                    top: '12px',
                    left: '50px',
                    right: '50px',
                    zIndex: 0
                }}
            />

            {/* Progress line - filled portion */}
            <div
                className='absolute h-[3px] bg-teal-600 transition-all duration-500'
                style={{
                    top: '12px',
                    left: '50px',
                    width: steps.length > 1
                        ? `calc(${((currentStep - 1) / (steps.length - 1)) * 100}% - 100px * ${(currentStep - 1) / (steps.length - 1)})`
                        : '0%',
                    zIndex: 1
                }}
            />

            {/* Steps */}
            {steps.map((step, index) => {
                const isActive = (index + 1) === currentStep;
                const isCompleted = (index + 1) < currentStep;

                return (
                    <div key={index} className='flex flex-col items-center relative' style={{ zIndex: 2 }}>
                        <div
                            className={`
                                w-6 h-6 rounded-full border-[3px] flex items-center justify-center
                                transition-all duration-300
                                ${isCompleted
                                    ? 'bg-teal-600 border-teal-600'
                                    : isActive
                                        ? 'bg-white border-teal-600'
                                        : 'bg-white border-gray-300'
                                }
                            `}
                        >
                            {isCompleted && <Check size={14} className='text-white' strokeWidth={3} />}
                        </div>

                        <div
                            className={`
                                mt-2 text-[12px] font-semibold whitespace-nowrap
                                ${isActive || isCompleted ? 'text-gray-800' : 'text-gray-400'}
                            `}
                        >
                            {step?.title}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default Stepper;
